export const findAllHashtags = (value: string) => {
  const regexp = /#[A-Za-z0-9àâáåäãąæœçĉćčďðèéêëęěĝğĥîìíïıĵłľñńňòöôóõøřŝşśšßťþùúûŭüůýźżž&_-]+/g;
  const array = value.match(regexp);
  return (array || []).map(tag => tag.substring(1).toLowerCase());
};

export const getDiscoverLessonUrl = ({
  templateName,
  templateId,
}: {
  templateName?: string | null;
  templateId: string;
}) => {
  if (templateName)
    return `/discover/${templateName
      .replace(/\s/g, '-')
      .replace(/[^\w\s\-]/gi, '')}/t/${templateId}`;
  return `/discover/Untitled/t/${templateId}`;
};

export const getGeneratorsUrl = ({
  title,
  generatorId,
}: {
  title?: string | null;
  generatorId: string;
}) => {
  if (title)
    return `/generators/${title
      .replace(/\s/g, '-')
      .replace(/[^\w\s\-]/gi, '')}/g/${generatorId}`;
  return `/generators/Untitled/g/${generatorId}`;
};
export const getDiscoverCreatorUrl = (creatorName: string, creatorId: string) => {
  return `/discover/${creatorName
    .replace(/\s/g, '-')
    .replace(/[^\w\s\-]/gi, '')}/c/${creatorId}`;
};
